import {FRAGMENTS, HELPED_FRAGMENTS} from '../enums/enums';
import {replaceSquareBrackets} from './replaceSquareBrackets';

export const getEventId = (buttonElement, formElement) => {
  let eventId = [];
  const facebookBusinessElement = document.querySelector(FRAGMENTS.DATA_ELEMENT);
  const ids = buttonElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_SUBMIT_EVENT_INPUT_IDS));
  const eventName = buttonElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_SUBMIT_EVENT_NAME));
  const webSystemId = facebookBusinessElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.WEB_SYSTEM_ID));

  if (ids) {
    const idsArray = ids.split(';');
    idsArray.forEach((id) => {
      const input = formElement.querySelector(`input[name="frm.${id}"]`);
      if (input && input.value) {
        eventId.push(input.value);
      }
    });
  }

  // TODO: až bude v config/module-facebook-business/module-facebook-business.xml:27 nadefinovaný webSystemId, tak přepnout return
  // return `${eventName}_${webSystemId}_${eventId.filter(Boolean).join('_')}`;
  return `${eventName}_${eventId.filter(Boolean).join('_')}`;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getEventId.js